export default __webpack_public_path__ + "static/media/img6.cb9ba1af.jpg";